module.exports = __webpack_public_path__ + "static/img/MaulanaRikiAlamsyah.43a158e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/MaulanaRikiAlamsyah.png
// module id = Ytsd
// module chunks = 36